export function encodeExcelCsv(text: string): ArrayBuffer {
  const buffer = new ArrayBuffer(2 + text.length * 2);
  const view = new DataView(buffer);

  view.setUint16(0, 0xfeff, true);
  for (let index = 0; index < text.length; index += 1) {
    view.setUint16(2 + index * 2, text.charCodeAt(index), true);
  }

  return buffer;
}
